import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';

import { FinancialService } from '../financial.service';

interface BudgetMonthlyDataViewModel {
    budgetId: string;
    budgetType: string;
    linkedEmployeeId?: string;
    linkedEmployeeName?: string;
    startDate: string;
    endDate: string;
    totalSpend: number;
    year: number;
    monthlyPlanned: number[];
    monthlyActual: number[];
    ytdPlanned: number;
    ytdActual: number;
    overBudget: boolean;
    yukiAccounts: string[];
}

@Component({
    selector: 'app-budget-overview',
    templateUrl: './budget-overview.component.html',
    styleUrls: ['./budget-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BudgetOverviewComponent implements OnInit, OnDestroy {
    year = new Date().getFullYear();
    budgets: BudgetMonthlyDataViewModel[] = [];
    sub?: Subscription;

    constructor(private financialService: FinancialService, private fb: UntypedFormBuilder) {}

    ngOnInit(): void {
        this.load();
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    setYear(y: number) {
        this.year = y;
        this.load();
    }

    load() {
        this.sub = this.financialService.getBudgetsMonthly(this.year).subscribe((data) => {
            this.budgets = data;
        });
    }

    getMonthLabel(i: number) {
        return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][i];
    }

    trackById(_: number, item: BudgetMonthlyDataViewModel) {
        return item.budgetId;
    }
}
